import { useQuery } from '@tanstack/react-query';
import {
  fetchAllFieldDetails,
  fetchAllMetricData,
  fetchAllProducers,
  fetchBankDocEnum,
  fetchFieldById
} from './fetchers';
import { queryKeys } from '../keys';

//  Hook for field details list
export const useFieldDetails = (params = {}) =>
  useQuery({
    queryKey: [...queryKeys.allFieldDetails, params],
    queryFn: () => fetchAllFieldDetails(params)
  });

//  Hook for metrics
export const useMetricData = (params = {}) =>
  useQuery({
    queryKey: [...queryKeys.allMetricData, JSON.stringify(params)],
    queryFn: () => fetchAllMetricData(params)
  });

//  Hook for field by ID
export const useFieldById = (params) =>
  useQuery({
    queryKey: [...queryKeys.fieldById, JSON.stringify(params)],
    queryFn: () => fetchFieldById(params),
    enabled: Boolean(params?.id),
    staleTime: 0
  });

export const useAllProducers = (params = {}) =>
  useQuery({
    queryKey: [...queryKeys.allProducers, JSON.stringify(params)],
    queryFn: () => fetchAllProducers(params),
    staleTime: 0
  });


export const useBankTypes = (params = {}) =>
  useQuery({
    queryKey: [...queryKeys.bankTypeEnum, JSON.stringify(params)],
    queryFn: () => fetchBankDocEnum(params),
    staleTime: 0
  }); 